export default "__VITE_ASSET__BP5fRJ$V__"